import { toast } from 'react-toastify';
import { ValidStringChecker } from '../../Utils/ValidStringChecker';
import { invalidEmail } from '../../Utils/InvalidValidStrings';

const Payment = (
  plan,
  email,
  product,
  type,
  amount,
  action,
  loader,
  source,
  history,
  gateway,
) => {
  let obj = {
    plan: plan && plan,
    email: email && email,
    product: product && product,
    type: type,
    request_origin: source ? source : 'console',
    payment_gateway: gateway ? gateway : 'stripe',
  };

  let obj2 = {
    plan: plan && plan,
    email: email && email,
    product: product && product,
    amount: amount && amount,
    request_origin: source ? source : 'console',
    payment_gateway: gateway ? gateway : 'stripe',
  };

  const invalidChars = ValidStringChecker(invalidEmail, email);
  var errorTrack;
  var errorMessage;

  if (invalidChars.length) {
    toast.error(
      `Currently only email id's without special characters (${invalidChars}) are supported for product purchase. Contact support for more details.`,
    );
  } else {
    const requestPostOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(obj),
    };
    const requestOptions = {
      method: action === 'change' ? 'PUT' : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(obj2),
    };
    loader(true);
    fetch(
      product === 'BUY' || product === 'INSIGHTS'
        ? `${process.env.REACT_APP_PAYMENT_URL}request`
        : `${process.env.REACT_APP_PAYMENT_URL}daily-limit`,
      product === 'BUY' || product === 'INSIGHTS' ? requestPostOptions : requestOptions,
    )
      .then((response) => {
        response.status >= 400
          ? ((errorTrack = true), (errorMessage = response))
          : (errorTrack = false);
        return response.json();
      })
      .then((data) => {
        // if (errorMessage.status >= 400) {
        //   toast.error(data.err);
        // }
        if (!errorTrack) {
          loader(false);
          if (data.paymentURL) {
            window.location.href = data.paymentURL;
          } else {
            history.push({
              pathname: '/payment',
              state: {
                client_secret: data?.clientSecret,
                plan: plan,
                product: product,
                amount: amount,
              },
            });
          }
        } else {
          loader(false);
          toast.error(errorMessage.err);
        }
      })
      .catch((err) => toast.error(err));
  }
};

export default Payment;
